var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('Navbar')],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-container',{staticClass:"pull-down"},[_c('router-view')],1)],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }